(() => {
  function updateStatus(select) {
    const section = select.closest('.js-product-section');
    if (!section) return;

    const form = select.closest('[data-product-form]');
    if (!form) return;

    const details = section.querySelector('[data-transit-status]');
    const cyberBadge = section.querySelector('[data-cyber-unavailable-badge]');
    if (!details && !cyberBadge) return;

    const variantId = select.value;
    if (details) {
      const inTransit = details.dataset.transitVariantIds.includes(`|${variantId}|`);
      details.hidden = !inTransit;
      const oct8 = inTransit && details.dataset.oct8VariantIds.includes(`|${variantId}|`);
      details.querySelectorAll('[data-oct8-badge], [data-oct8-message]').forEach(item => { item.hidden = !oct8; });
      details.querySelectorAll('[data-other-badge], [data-other-message]').forEach(item => { item.hidden = !inTransit || oct8; });
      section.classList.toggle('has-transit-variant', inTransit);
    }

    if (cyberBadge) {
      let product;
      try {
        product = JSON.parse(form.getAttribute('data-product'));
      } catch (_) {
        cyberBadge.hidden = true;
        return;
      }
      const variant = product.variants.find(item => String(item.id) === variantId);
      cyberBadge.hidden = !(variant && !variant.available &&
        Number(variant.compare_at_price) > Number(variant.price));
    }
  }

  document.addEventListener('change', event => {
    const select = event.target;
    if (select instanceof HTMLSelectElement && select.matches('[data-variants]')) {
      updateStatus(select);
    }
  }, true);

  function initialize() {
    document.querySelectorAll('[data-transit-status]').forEach(status => {
      const section = status.closest('.js-product-section');
      const select = section && section.querySelector('[data-product-form] [data-variants]');
      if (select) updateStatus(select);
    });
  }

  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState !== 'loading') initialize();
})();
